import { useQuery } from '@tanstack/react-query'
import { purchaseOrdersRHService } from '@/features/rh/api/purchaseOrdersRH.service'
import type { PurchaseOrderRHFilters } from '../types/purchaseOrderRH.types'

/** Prefijo de la caché del listado. Invalidarlo refresca cualquier filtro. */
export const LLAVE_ORDENES_RH = ['purchase-orders-rh'] as const

export const usePurchaseOrdersRH = (filters?: PurchaseOrderRHFilters) => {
  return useQuery({
    queryKey: [...LLAVE_ORDENES_RH, filters],
    queryFn: () => purchaseOrdersRHService.getOrders(filters),
    staleTime: 30000, // 30 segundos
    refetchOnWindowFocus: false
  })
}

export const usePurchaseOrderRHById = (orderId: string) => {
  return useQuery({
    queryKey: ['purchase-order-rh', orderId],
    queryFn: () => purchaseOrdersRHService.getOrderById(orderId),
    enabled: !!orderId,
    staleTime: 30000
  })
}
